<div class="page-container">
  <app-page-header title="Commercial Requests" [showBackButton]="true" backRoute="/userhome"
    backLabel="Back to Dashboard">
    @if (isUserRole) {
    <button class="btn-primary filter-btn" routerLink="/production-requests/create">
      <span class="icon material-icons" aria-hidden="true">add</span>
      <span class="btn-label">New Request</span>
    </button>
    }
  </app-page-header>

  <div class="content-wrapper">
    @if (loading) {
    <div class="loading-wrap">
      <app-data-loader [show]="true" message="Loading requests..." size="medium" />
    </div>
    } @else if (error) {
    <div class="error-message" role="alert">
      <mat-icon>error_outline</mat-icon>
      {{ error }}
    </div>
    } @else if (requests.length === 0) {
    <div class="empty-state">
      <mat-icon>campaign</mat-icon>
      <p>{{ isUserRole ? 'No commercial requests yet.' : 'No commercial requests assigned to your station.' }}</p>
      @if (isUserRole) {
      <a class="btn-primary filter-btn" routerLink="/production-requests/create"
        style="text-decoration: none; color: white;">
        <span class="icon material-icons" aria-hidden="true">add</span>
        <span class="btn-label">Create Request</span>
      </a>
      }
    </div>
    } @else {
    @if (showOwnerStationFilters) {
    <div class="filters-row">
      <app-owner-station-filters [userRole]="userRole" (filterChange)="onOwnerStationFilterChange($event)" />
    </div>
    }
    <div class="cards-grid">
      @for (r of requests; track r.id) {
      <a [routerLink]="['/production-requests', r.id]" class="request-card">
        @if ((r.unread_notification_count ?? 0) > 0) {
        <mat-icon class="card-notification-bell" title="Unread notifications">notifications</mat-icon>
        }
        <div class="card-header">
          <span class="card-title-wrap">
            <span class="card-title">Request #{{ r.id }}</span>
          </span>
          @if ((r.message_count ?? 0) > 0 || (r.audio_count ?? 0) > 0) {
          <span class="activity-indicators">
            @if ((r.message_count ?? 0) > 0) {
            <span class="activity-badge new-message">New Message</span>
            }
            @if ((r.audio_count ?? 0) > 0) {
            <span class="activity-badge new-audio">New Audio</span>
            }
          </span>
          }
        </div>
        @if (isUserRole) {
        <p class="card-line">Station: {{ r.station_name || '—' }}</p>
        } @else {
        <p class="card-line">User: {{ r.user_email || ('User #' + r.user_id) }}</p>
        }
        <p class="card-line">
          <span class="status-badge" [ngClass]="getStatusClass(r.status)">
            {{ statusLabels[r.status] || r.status }}
          </span>
        </p>
        <p class="card-line muted">Created: {{ r.created_at | date:'mediumDate' }}</p>
        @if (isUserRole && r.preview) {
        <p class="card-preview">{{ r.preview }}</p>
        }
        <span class="card-link">View request</span>
      </a>
      }
    </div>
    }
  </div>
</div>